import { creditsToYuan } from './currency';

export function formatCreditsAsYuan(credits?: number | null): string {
  if (!credits) return '-';
  return creditsToYuan(credits);
}
